
/* injects from baggage-loader */

'use strict';

import SignupController from './signup.controller';
import SignupTemplate from './signup.html';

export default class SignupComponent {
		constructor() {
				this.templateUrl = SignupTemplate;
				this.controller = SignupController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.component.js